import { ca } from '@cian/analytics';

export function trackNavigationToListingJK(id?: number) {
  return ca('eventSite', {
    name: 'oldevent',
    category: 'CompareJK',
    action: 'to_listingjk',
    ...(id ? { products: [{ id, offerType: 'JK' }] } : {}),
  });
}
